import { ShieldCheck, Hourglass, Eye, Brush } from "lucide-react";
import Reveal from "./Reveal";

const items = [
  {
    icon: ShieldCheck,
    title: "Skonsamma metoder",
    text: "Vi arbetar varsamt mot tak och fasad och undviker metoder som kan riskera att skada ytan.",
    testid: "feature-card-1",
  },
  {
    icon: Hourglass,
    title: "Längre livslängd",
    text: "Rätt underhåll i rätt tid kan bidra till att tak och fasad håller sig i bättre skick längre.",
    testid: "feature-card-2",
  },
  {
    icon: Eye,
    title: "Kontroll före & efter",
    text: "Vi går igenom arbetet före och efter, så att vi kan rekommendera och utföra rätt åtgärd.",
    testid: "feature-card-3",
  },
  {
    icon: Brush,
    title: "Rent och ordnat efteråt",
    text: "Vi städar efter oss och rensar hängrännor när arbetet är klart — så att allt är på plats.",
    testid: "feature-card-4",
  },
];

export default function WhyUs() {
  return (
    <section
      id="varfor-oss"
      data-testid="section-why-us"
      className="bg-[#EAE5D9] py-24 md:py-32 relative"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-end mb-14 md:mb-20">
          <Reveal className="lg:col-span-7">
            <div className="text-[11px] tracking-[0.22em] uppercase text-[#1A362B]/70">
              Varför oss
            </div>
            <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#1F2321] text-balance">
              Hantverk som <span className="text-[#1A362B]">håller över tid</span>
            </h2>
          </Reveal>
          <Reveal className="lg:col-span-5">
            <p className="text-[#1F2321]/80 leading-relaxed">
              Vi tror på enkelt, ärligt arbete. Vi lovar inte mer än vi kan
              hålla — istället visar vi vad vi gör och varför.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <Reveal
                key={it.title}
                delay={i * 80}
                data-testid={it.testid}
                className="bg-[#F7F5F0] border border-[#1A362B]/8 rounded-2xl p-7 md:p-8 h-full"
              >
                <div className="w-11 h-11 rounded-xl bg-[#1A362B] flex items-center justify-center">
                  <Icon size={18} className="text-[#F7F5F0]" strokeWidth={1.6} />
                </div>
                <h3 className="mt-7 font-serif-display text-xl md:text-[22px] text-[#1F2321] leading-tight">
                  {it.title}
                </h3>
                <p className="mt-3 text-[#5C6B64] text-[15px] leading-relaxed">
                  {it.text}
                </p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
